import "./App.css";
import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom";
import AppLayout from "./components/layout/AppLayout";
import Default from "./components/layout/contents/default/Default";
import "bootstrap/dist/css/bootstrap.min.css";
import Videos from "./components/layout/contents/videos/Videos";
import LoginPage from "./components/login/LoginPage";
import PrivateRoutes from "./components/utils/PrivateRoutes";
import Orders from "./components/layout/contents/order/Orders";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/home" replace />} />
        <Route path="login" element={<LoginPage />} />

        <Route element={<PrivateRoutes />}>
          <Route
            path="*"
            element={
              <AppLayout>
                <Routes>
                  <Route path="orders" element={<Orders />} />
                  <Route path="home" element={<Default />} />
                  <Route path="p/:assemblyCode" element={<Videos />} />
                </Routes>
              </AppLayout>
            }
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
